export default __webpack_public_path__ + "static/media/IconDesc_RadioControlUnit.256.4f07d4ee.png";